import { render } from "./DefaultSearchSectionResultCmp.vue?vue&type=template&id=0fd891b2"
import script from "./DefaultSearchSectionResultCmp.vue?vue&type=script&lang=js"
export * from "./DefaultSearchSectionResultCmp.vue?vue&type=script&lang=js"

import "./DefaultSearchSectionResultCmp.vue?vue&type=style&index=0&id=0fd891b2&lang=css"

import exportComponent from "D:\\working\\MyCi4Vue\\myCi4Vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__